import { useUserPreferences } from './useUserPreferences';
import { ViewMode } from '../types/api';
import { ThemeColor } from '../types/theme';

export function useDisplaySettings() {
  const {
    preferences,
    setBookmarkListView,
    setBookmarkListThumbnails,
    setBookmarkListSortOrder,
    color,
    setColor,
  } = useUserPreferences();

  const handleColorChange = (newColor: ThemeColor) => {
    setColor(newColor);
  };

  const handleCondensedViewToggle = (checked: boolean) => {
    setBookmarkListView(checked ? 'condensed' : 'standard');
  };

  const handleThumbnailsToggle = (checked: boolean) => {
    setBookmarkListThumbnails(checked);
  };

  const handleSortOrderToggle = () => {
    const newOrder =
      preferences.bookmarkList.sortOrder === 'newest' ? 'oldest' : 'newest';
    setBookmarkListSortOrder(newOrder);
  };

  // Determine which modes support certain features
  const getFeatureVisibility = (mode?: ViewMode) => {
    const showAppearanceOptions = [
      'unread',
      'archive',
      'starred',
      'folder',
      'highlights',
      'browse',
      'search',
      'feature',
      'daily',
      'friends',
      'profile',
      'friendfinder',
      'tags',
      'tags_list',
      'videos',
    ].includes(mode || 'unread');

    const showListOptions = [
      'unread',
      'archive',
      'starred',
      'folder',
      'videos',
      'tags',
    ].includes(mode || 'unread');

    return { showAppearanceOptions, showListOptions };
  };

  return {
    preferences,
    color,
    handlers: {
      handleColorChange,
      handleCondensedViewToggle,
      handleThumbnailsToggle,
      handleSortOrderToggle,
    },
    getFeatureVisibility,
  };
}
